import React from 'react'
import { connect } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { first } from 'lodash'
import PropTypes from "prop-types"

import Button from '../../components/Button'
import ExplanationPrompt from "./ExplanationPrompt"
import ActionTypes from '../../actions/ActionTypes'

/**
 * Prompt component
 */

const customPrompts = {
  explanation: ExplanationPrompt
}

const UnconnectedPrompts = ({ prompt, onButtonClick }) => {
  if (!prompt) return <span></span>

  if (prompt.custom) {
    const P = customPrompts[prompt.key]
    return <P {...prompt.props} onButtonClick={onButtonClick} />
  }

  return (
    <Modal show onHide={() => this.props.onButtonClick(null)}>
      <Modal.Header>
        <Modal.Title>
          {prompt.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {prompt.text}
      </Modal.Body>
      <Modal.Footer>
        {
          prompt.buttons.map(b => (
            <Button
              key={b.k}
              bsStyle={b.style}
              glyph={b.glyph}
              onClick={() => onButtonClick(b.action)}
            >
              {b.text}
            </Button>
          ))
        }
      </Modal.Footer>
    </Modal>
  )
}

UnconnectedPrompts.propTypes = {
  prompt: PropTypes.object, // #TODO specify shape
  onButtonClick: PropTypes.func.isRequired
}

const mapStateToProps = state => ({ prompt: first(state.ui.prompts) })

const mapDispatchToProps = dispatch => ({
  onButtonClick: buttonAction => {
    if (buttonAction) {
      dispatch(buttonAction);
    }
    dispatch({ type: ActionTypes.CLOSE_FIRST_PROMPT })
  }
})

const Prompts = connect(mapStateToProps, mapDispatchToProps)(UnconnectedPrompts)

export default Prompts
